import { AxiosProgressEvent, AxiosResponse } from "axios";
import { api } from "./api";

const SITE = "AFESP_CONVENIOS";

export type UploadCategory =
  | "NOTICIAS"
  | "CONTEUDO"
  | "CARROSSEL"
  | "ADS"
  | "CONVENIADOS"
  | "DESCONTOS"
  | "OUTROS";

export interface UploadResponse {
  id: number | string;
  url: string;
  fileName: string;
  contentType: string;
  size: number;
}

interface UploadImageParams {
  file: File;
  category: UploadCategory;
  contentId?: number | string;
  onProgress?: (progress: number) => void;
  signal?: AbortSignal;
}

const uploadImage = ({
  file,
  category,
  contentId,
  onProgress,
  signal,
}: UploadImageParams): Promise<AxiosResponse<UploadResponse>> => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("site", SITE);
  formData.append("category", category);

  if (contentId !== undefined) {
    formData.append("contentId", String(contentId));
  }

  return api.post("uploads", formData, {
    signal,
    onUploadProgress: (event: AxiosProgressEvent) => {
      if (event.total && onProgress) {
        onProgress(Math.round((event.loaded * 100) / event.total));
      }
    },
  });
};

const uploadService = { uploadImage };

export default uploadService;
